import { handleActions } from "redux-actions";

import {
  LOGIN_SUCCESS,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_DOCUMENT_START,
  UPLOAD_DOCUMENT_ERROR,
  GET_DOCUMENT_SUCCESS,
  GET_PROCESSED_PAGE_SUCCESS,
  GET_PROCESSED_PAGE_ERROR,
  GET_EXTRACTIONS_SUCCESS,
  ADD_BOUNDING_BOXES,
  SET_ACTIVE_BOXES,
  ADD_LINE,
  REMOVE_LINES,
  SET_CURRENT_PAGE_INDEX,
  IMAGES_LOADED,
  GET_DOCUMENT_ERROR,
  GET_EXTRACTIONS_ERROR
} from "./action";

const defaultState = {
  isAuthenticated: false,
  accessToken: localStorage.getItem("accessToken") || "",
  tokenType: localStorage.getItem("tokenType") || "",
  documentId: "",
  documentType: "",
  isUploading: false,
  isProcessing: false,
  imagesLoaded: true,
  pages: null,
  currentPage: "",
  error: false,
  extractionsError: false,
  extractions: null,
  bboxes: {
    byId: {}
  },
  activeBoxes: [],
  lines: []
};

const reducer = handleActions(
  {
    [LOGIN_SUCCESS]: (state, { payload }) => ({
      ...state,
      accessToken: payload.accessToken,
      tokenType: payload.tokenType
    }),
    [UPLOAD_DOCUMENT_START]: (state) => ({
      ...state,
      documentId: "",
      error: false,
      extractionsError: false,
      isUploading: true,
      isProcessing: false,
      imagesLoaded: false,
      extractions: {
        byPageId: {}
      },
      bboxes: {
        byId: {}
      },
      currentPage: null
    }),
    [UPLOAD_DOCUMENT_SUCCESS]: (state, { payload }) => ({
      ...state,
      documentId: payload.documentId,
      isUploading: false,
      isProcessing: true
    }),
    [UPLOAD_DOCUMENT_ERROR]: (state) => ({
      ...state,
      isUploading: false
    }),
    [GET_DOCUMENT_SUCCESS]: (state, { payload }) => ({
      ...state,
      isProcessing: false,
      documentType: payload.documentType
    }),
    [GET_DOCUMENT_ERROR]: (state) => ({
      ...state,
      isProcessing: false,
      error: true
    }),
    [GET_PROCESSED_PAGE_SUCCESS]: (state, { payload }) => ({
      ...state,
      pages: payload,
      currentPage: 0
    }),
    [GET_PROCESSED_PAGE_ERROR]: (state, { error }) => ({
      ...state,
      error: true
    }),
    [GET_EXTRACTIONS_SUCCESS]: (state, { payload }) => ({
      ...state,
      extractions: payload
    }),
    [GET_EXTRACTIONS_ERROR]: (state, { payload }) => ({
      ...state,
      extractionsError: true,
      error: true
    }),
    [ADD_BOUNDING_BOXES]: (state, { payload }) => ({
      ...state,
      bboxes: payload
    }),
    [SET_ACTIVE_BOXES]: (state, { payload }) => ({
      ...state,
      activeBoxes: payload
    }),
    [ADD_LINE]: (state, { payload }) => ({
      ...state,
      lines: [...state.lines, payload]
    }),
    [REMOVE_LINES]: (state) => ({
      ...state,
      lines: []
    }),
    [SET_CURRENT_PAGE_INDEX]: (state, { payload }) => ({
      ...state,
      currentPage: payload
    }),
    [IMAGES_LOADED]: (state, { payload }) => ({
      ...state,
      imagesLoaded: payload
    })
  },
  defaultState
);

export default reducer;
